import { IInfoCookies, IResponseInfoCookies } from '../types/infoCookies';
import { appStore } from '~/mobx/appStore';

export const infoCookiesDataCast = (data: IResponseInfoCookies): IInfoCookies => {
  return {
    message: {
      en: String(data?.message?.en) || '',
      ar: String(data?.message?.ar) || '',
    },
    title: {
      en: String(data?.title?.en) || '',
      ar: String(data?.title?.ar) || '',
    },
    cookiesEnabled: appStore.settings?.cookies_enabled || 0,
  };
};
